import { makeStyles } from '@material-ui/core';
// import { ObtienePersona } from "../../../application/interactors/Postulante";
import {
    ObtieneDatosPersonales,
    GrabarDatosPersonales,
    ObtieneDatosTipoPersonaPorPostulacion,
    BloqueoPorRut,
} from '../../../application/interactors/DatosPersonales';
import IViewRequisitosAsegurado from '../../view-interfaces/IViewRequisitosAsegurado';
import IViewRequisitosRF from '../../view-interfaces/IViewRequisitosRF';

export const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    demo: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    buttonProgress: {
        color: theme.palette.primary.light,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

export const ObtieneRequisitosRFLogic = (selListaRequisitos: any) => {
    let list: Array<IViewRequisitosRF> = [];
    list.push({
        ID: 1,
        descripcion: 'Debe ser una persona natural mayor de 18 años.',
    });
    list.push({
        ID: 2,
        descripcion: 'Debe tener nacionalidad chilena o con residencia definitiva en Chile.',
    });
    list.push({
        ID: 3,
        descripcion:
            'Debe tener cédula de identidad vigente nacional o cédula de identidad para extranjeros con residencia definitiva según sea el caso.',
    });
    list.push({
        ID: 4,
        descripcion:
            'El responsable financiero será el asegurado para efectos de la Universidad del Desarrollo, siempre y cuando cumpla con los siguientes requisitos: ser mayor de 18 años y menor de 65 años en caso de cobertura de invalidez, y de 70 años para la cobertura de fallecimiento.',
    });
    list.push({
        ID: 5,
        descripcion: 'El seguro vida escolar comienza en marzo.',
    });

    return selListaRequisitos(false, '', list);
};

//El parámetro Postulaciones es opcional (no es necesaria para llamar a la Api), solo se utilizó para optener los datos de la postulación.
export const ObtieneDatosPersonalesLogic = (
    selListaPersona: any,
    headers: any,
    rut: number,
    pasaporte: string,
    codigoNegocio: number,
    tipoPersona: number,
    idPeriodo: number = 0,
    Postulaciones: any = undefined,
    /* token: string */
) => {
    idPeriodo = idPeriodo || 0; // Establecer 0 como valor predeterminado si idPeriodo no viene
    return ObtieneDatosPersonales(
        selListaPersona,
        rut,
        pasaporte,
        codigoNegocio,
        tipoPersona,
        idPeriodo,
        Postulaciones,
        headers
    );
};

//El parámetro Postulaciones es opcional (no es necesaria para llamar a la Api), solo se utilizó para optener los datos de la postulación.
export const GrabarDatosPersonalesLogic = (
    selGrabarDatosPersonales: any,
    headers: any,
    idPersona: number,
    run: string,
    pasaporte: string,
    nombres: string,
    primerApellido: string,
    segundoApellido: string,
    fechaNacimiento: Date,
    codigoComuna: number,
    nombreComuna: string,
    direccion: string,
    telefono: number,
    email: string,
    codSexo: number,
    sexo: string,
    idPais: number,
    pais: string,
    idNacionalidad: number,
    nacionalidad: string,
    rutAlumno: number,
    codigoNegocio: number,
    codigoPrograma: string,
    anioPromocion: number,
    periodoPromocion: number,
    codigoPlanificacion: number,
    tipoPersona: number,
    Postulaciones: any = undefined,
) => {
    return GrabarDatosPersonales(
        selGrabarDatosPersonales,
        headers,
        idPersona,
        run,
        pasaporte,
        nombres,
        primerApellido,
        segundoApellido,
        fechaNacimiento,
        codigoComuna,
        nombreComuna,
        direccion,
        telefono,
        email,
        codSexo,
        sexo,
        idPais,
        pais,
        idNacionalidad,
        nacionalidad,
        rutAlumno,
        codigoNegocio,
        codigoPrograma,
        anioPromocion,
        periodoPromocion,
        codigoPlanificacion,
        tipoPersona,
        Postulaciones,
    );
};

// export const ObtienePersonaLogic = (selListaPersona: any, rut: number) => {
//   return ObtienePersona(selListaPersona, rut);
// }

// export const ObtieneRUTPasaporteLogic = (selRut: any, pasaporte: string) => {
//   return ObtieneRUTPasaporte(selRut, pasaporte);
// }
// export const ObtieneRepresentanteLegalLogic = (selListaRepresentanteLegal: any,
//   rut: number, codigoPrograma: string, codigoNegocio: number, numeroAlumno: string, rutRF: number) => {
//   return ObtieneRepresentanteLegal(selListaRepresentanteLegal, rut, codigoPrograma, codigoNegocio, numeroAlumno, rutRF);
// }
// export const ObtieneRepresentanteFinancieroLogic = (selListaRepresentanteFinanciero: any,
//   rut: number, codigoPrograma: string, codigoNegocio: number, numeroAlumno: string) => {
//   return ObtieneRepresentanteFinanciero(selListaRepresentanteFinanciero, rut, codigoPrograma, codigoNegocio, numeroAlumno);
// }

export const ObtieneDatosTipoPersonaPorPostulacionLogic = (
    selListaDatosTipoPersona: any,
    headers: any,
    rutAlumno: number,
    codigoNegocio: number,
    codigoPrograma: string,
    anioPromocion: number,
    periodoPromocion: number,
    codigoPlanificacion: number,
    tipoPersona: number,
    idPeriodo: number,
    idRefirma: number = 0
) => {
    return ObtieneDatosTipoPersonaPorPostulacion(
        selListaDatosTipoPersona,
        headers,
        rutAlumno,
        codigoNegocio,
        codigoPrograma,
        anioPromocion,
        periodoPromocion,
        codigoPlanificacion,
        tipoPersona,
        idPeriodo,
        idRefirma
    );
};

// export const GrabarRepresentanteFinancieroLogic = (selGrabarRepresentanteFinanciero: any,
//   codigoNegocio: number,
//   rutPostulante: number,
//   rut: number,
//   dv: string,
//   nombres: string,
//   apPaterno: string,
//   apMaterno: string,
//   fechaNacimiento: Date,
//   idGenero: number,
//   genero: string,
//   telefono: string,
//   mail: string,
//   direccion: string,
//   idComuna: string,
//   comuna: string,
//   idPais: number,
//   nacionalidad: string,
//   numeroAlumno: string) => {
//   return GrabarRepresentanteFinanciero(selGrabarRepresentanteFinanciero, codigoNegocio, rutPostulante, rut, dv, nombres,
//     apPaterno, apMaterno, fechaNacimiento, idGenero, genero, telefono, mail,
//     direccion, idComuna, comuna, idPais, nacionalidad, numeroAlumno);
// }

// export const ObtieneAseguradoLogic = (selListaAsegurado: any, rut: number, codigoPrograma: string, codigoNegocio: number) => {
//   return ObtieneAsegurado(selListaAsegurado, rut, codigoPrograma, codigoNegocio);
// }
// export const GrabarRepresentanteLegalLogic = (selGrabarRepresentanteLegal: any,
//   codigoNegocio: number,
//   rutPostulante: number,
//   rut: number,
//   dv: string,
//   nombres: string,
//   apPaterno: string,
//   apMaterno: string,
//   fechaNacimiento: Date,
//   idGenero: number,
//   genero: string,
//   telefono: string,
//   mail: string,
//   direccion: string,
//   idComuna: string,
//   comuna: string,
//   idPais: number,
//   nacionalidad: string,
//   numeroAlumno: string) => {
//   return GrabarRepresentanteLegal(selGrabarRepresentanteLegal, codigoNegocio, rutPostulante, rut, dv, nombres,
//     apPaterno, apMaterno, fechaNacimiento, idGenero, genero, telefono, mail,
//     direccion, idComuna, comuna, idPais, nacionalidad, numeroAlumno);
// }
export const ObtieneRequisitosAseguradoLogic = (selListaRequisitos: any) => {
    let list: Array<IViewRequisitosAsegurado> = [];

    /* list.push({
    ID: 1,
    descripcion: "El Asegurado es quien asume ante la Universidad el compromiso de pago del arancel del alumno."
  });
  list.push({
    ID: 2,
    descripcion: "Debe ser nacionalidad chilena o con residencia definitiva en Chile"
  });
  list.push({
    ID: 3,
    descripcion: "Debe ser una persona natural (mayor de 18 años)."
  });
  list.push({
    ID: 4,
    descripcion: "Debe tener un ingreso mensual superior al valor de cada mensualidad."
  });
  list.push({
    ID: 5,
    descripcion: "Debe informarse en la web con los dos nombres y los dos apellidos (en ese orden respectivamente), tal y cómo se detallan en su Cédula Nacional de Identidad."
  }); */
    list.push({
        ID: 1,
        descripcion:
            'Debe ser mayor de 18 años  y menor de 65 en caso de cobertura de invalidez, y de 70 años para la cobertura de fallecimiento.',
    });
    list.push({
        ID: 2,
        descripcion:
            'Dado que ésta póliza de vida y/o invalidez permitirá cubrir el pago del arancel de la carrera, el asegurado debe ser el Responsable Financiero (siempre y cuando cumpla con los requisitos, en caso contrario puede ser otra persona)',
    });
    /* list.push({
    ID: 3,
    descripcion: "En caso de muerte la póliza cubre hasta los 75 años y, en caso de invalidez 2/3, cubre hasta los 65 años."
  }); */
    list.push({
        ID: 4,
        descripcion: 'El seguro vida escolar comienza en marzo.',
    });

    return selListaRequisitos(false, '', list);
};

export const BloqueoPorRutLogic = (
    selBloqueoPorRut: any,
    rutAlumno: number,
    codigoNegocio: number,
    codigoPrograma: string,
    anioPromocion: number,
    periodoPromocion: number,
    codigoPlanificacion: number,
    rutPersona: number,
) => {
    return BloqueoPorRut(
        selBloqueoPorRut,
        rutAlumno,
        codigoNegocio,
        codigoPrograma,
        anioPromocion,
        periodoPromocion,
        codigoPlanificacion,
        rutPersona,
    );
};

// export const ObtieneContactoLogic = (selListaContacto: any, rut: number, codigoPrograma: string, codigoNegocio: number) => {
//   return ObtieneContacto(selListaContacto, rut, codigoPrograma, codigoNegocio);
// }

// export const GrabarAseguradoLogic = (selGrabarAsegurado: any,
//   codigoNegocio: number,
//   rutPostulante: number,
//   rut: number,
//   dv: string,
//   nombres: string,
//   apPaterno: string,
//   apMaterno: string,
//   fechaNacimiento: Date,
//   idGenero: number,
//   genero: string,
//   telefono: string,
//   mail: string,
//   direccion: string,
//   idComuna: string,
//   comuna: string,
//   idPais: number,
//   nacionalidad: string,
//   numeroAlumno: string) => {
//   return GrabarAsegurado(selGrabarAsegurado, codigoNegocio, rutPostulante, rut, dv, nombres,
//     apPaterno, apMaterno, fechaNacimiento, idGenero, genero, telefono, mail,
//     direccion, idComuna, comuna, idPais, nacionalidad, numeroAlumno);
// }

// export const GrabarContactoLogic = (selGrabarAsegurado: any,
//   codigoNegocio: number,
//   rutPostulante: number,
//   rut: number,
//   dv: string,
//   nombres: string,
//   apPaterno: string,
//   apMaterno: string,
//   fechaNacimiento: Date,
//   idGenero: number,
//   genero: string,
//   telefono: string,
//   mail: string,
//   direccion: string,
//   idComuna: string,
//   comuna: string,
//   idPais: number,
//   nacionalidad: string,
//   numeroAlumno: string) => {
//   return GrabarContacto(selGrabarAsegurado, codigoNegocio, rutPostulante, rut, dv, nombres,
//     apPaterno, apMaterno, fechaNacimiento, idGenero, genero, telefono, mail,
//     direccion, idComuna, comuna, idPais, nacionalidad, numeroAlumno);
// }
